import { setLocale } from 'yup'
import * as yup from 'yup'
import { parsePhoneNumber, isValidPhoneNumber } from 'libphonenumber-js'

// Simple email regex - requires @ and TLD with at least 2 letters
const EMAIL_REGEX = /^.+@.+\.[a-z]{2,}$/i

// Add email validation
yup.addMethod(yup.string, 'email', function (message = 'Enter a valid email address.') {
  return this.test('email', message, function (value) {
    if (!value) return true // Handle optional emails
    if (value.length > 320) return false // RFC 3696
    return EMAIL_REGEX.test(value)
  })
})

// Add phone validation using libphonenumber-js
yup.addMethod(yup.string, 'phone', function (message = 'Enter a valid phone number.') {
  return this.test('phone', message, function (value) {
    if (!value) return true // Handle optional phone numbers
    try {
      return isValidPhoneNumber(value)
    } catch (error) {
      return false
    }
  })
})

// Set default locale
setLocale({
  mixed: {
    required: 'This field is required'
  },
  string: {
    email: 'Enter a valid email address.',
    phone: 'Enter a valid phone number.'
  }
})

export { yup }
